/* eslint-disable */
// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { container } from "../../../../api/Api";
import { order } from "@api/Api";
// ** Axios Imports

export const getContainers = createAsyncThunk(
  "appInvoiceCreate/getContainers",
  async () => {
    return container.getAllContainer();
  }
);

export const finalize = createAsyncThunk(
  "appInvoiceCreate/finalize",
  async (values) => {
    try {
      return order.finalize(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appInvoiceCreateSlice = createSlice({
  name: "appInvoiceCreate",
  initialState: {
    containers: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContainers.fulfilled, (state, action) => {
      state.containers = action.payload?.data?.data;
    });
  },
});

export default appInvoiceCreateSlice.reducer;
